import createReactComponent from '../createReactComponent';
var Inspect = createReactComponent('Inspect', [['path', {
  d: 'M19 11V4a2 2 0 00-2-2H4a2 2 0 00-2 2v13a2 2 0 002 2h7',
  key: '1ahu87'
}], ['path', {
  d: 'M12 12l4.166 10 1.48-4.355L22 16.166 12 12z',
  key: 'ert414'
}], ['path', {
  d: 'M18 18l3 3',
  key: '1722q3'
}]]);
export default Inspect;